import { Capacitor, registerPlugin } from "@capacitor/core";

export type NativeDeviceIdentityPlugin = {
  getDeviceId(): Promise<{ value: string | null }>;
  setDeviceId(options: { value: string }): Promise<void>;
  removeDeviceId(): Promise<void>;
};

export const NativeDeviceIdentity = registerPlugin<NativeDeviceIdentityPlugin>("NativeDeviceIdentity");

/** True when the native durable-identity plugin is linked (iOS Keychain / Android backup prefs). */
export const isNativeDeviceIdentityAvailable = () => {
  if (!Capacitor.isNativePlatform()) return false;
  const platform = Capacitor.getPlatform();
  if (platform !== "ios" && platform !== "android") return false;
  return Capacitor.isPluginAvailable("NativeDeviceIdentity");
};
